import { WEEKEND_MARKUP_RATE, WEEKDAYS_MARKUP_RATE } from "./constants";

/**
 * Weekdays: 0.2%
 * Friday 21:00-Monday 8:00 (CET): 0.5%
 */
const getAlpianMarkup = (timestamp: string | number) => {
  const date = new Date(timestamp);
  const day = date.getDay();
  const hours = date.getHours();

  if (
    (day === 5 && hours >= 21) ||
    day === 6 ||
    day === 0 ||
    (day === 1 && hours <= 8)
  ) {
    return WEEKEND_MARKUP_RATE;
  }

  return WEEKDAYS_MARKUP_RATE;
};

export const getAlpianExchange = (midMarketRate: number, unix: number) => {
  const alpianMarkup = getAlpianMarkup(unix * 1000);

  return midMarketRate * (1 - alpianMarkup / 100);
};

export const calculateConverterAmount = (
  amount: string,
  exchangeRate: number | null,
) => {
  const amountAsNumber = Number(amount);

  if (!exchangeRate || isNaN(amountAsNumber)) {
    return "0";
  }

  return (amountAsNumber * exchangeRate).toFixed(2);
};
